<script>
import { getDate } from '@/utils/date';

export default {
  name: 'TableCellDate',
  props: {
    timestamp: {
      type: Number,
      default: 0,
    },
    offset: {
      type: Number,
      default: 0,
    },
    locale: {
      type: String,
      default: 'pt_BR',
    },
  },
  computed: {
    date() {
      return getDate(this.timestamp, this.locale, this.offset, 'medium');
    },
  },
};
</script>

<template>
  <div>
    {{ date }}
  </div>
</template>
